export var Gender;
(function (Gender) {
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
    Gender["Other"] = "Other";
})(Gender || (Gender = {}));
export function getGenderName(gender) {
    switch (gender) {
        case Gender.Male:
            return 'Man';
        case Gender.Female:
            return 'Vrouw';
        case Gender.Other:
            return 'Andere';
    }
}
//# sourceMappingURL=Gender.js.map